module.exports = __webpack_public_path__ + "static/media/18ECA39.bdd8a792.jpg";